"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.files = ['a', 'b', 'c', 'd', 'e', 'f', 'g', 'h'];
exports.ranks = [1, 2, 3, 4, 5, 6, 7, 8];



//////////////////
// WEBPACK FOOTER
// ./node_modules/chessground/types.js
// module id = 5
// module chunks = 0